import { ReservationStatus } from '@/types';

export const RESERVATION_STATUS_OPTIONS = [
  { value: ReservationStatus.PENDING_PAYMENT, label: 'Pendiente de pago', visual: { icon: 'clock', color: 'text-amber-500' } },
  { value: ReservationStatus.CONFIRMED, label: 'Confirmada', visual: { icon: 'checkcircle2', color: 'text-green-500' } },
  { value: ReservationStatus.PREPARING_SHIPMENT, label: 'Preparando envío', visual: { icon: 'boxes', color: 'text-indigo-500' } },
  { value: ReservationStatus.IN_DELIVERY, label: 'En entrega', visual: { icon: 'waves', color: 'text-blue-500' } },
  { value: ReservationStatus.ACTIVE, label: 'Activa', visual: { icon: 'playcircle', color: 'text-blue-500' } },
  { value: ReservationStatus.IN_USE_ISSUE, label: 'Problema en uso', visual: { icon: 'error', color: 'text-amber-600' } },
  { value: ReservationStatus.IN_RETURN, label: 'En devolución', visual: { icon: 'rotateccw', color: 'text-indigo-600' } },
  { value: ReservationStatus.PENDING_RETURN, label: 'Pendiente de devolución', visual: { icon: 'clock', color: 'text-amber-500' } },
  { value: ReservationStatus.RETURNED, label: 'Devuelta', visual: { icon: 'checkcircle2', color: 'text-green-600' } },
  { value: ReservationStatus.COMPLETED, label: 'Completada', visual: { icon: 'checkcheck', color: 'text-green-700' } },
  { value: ReservationStatus.CANCELED, label: 'Cancelada', visual: { icon: 'xcircle', color: 'text-red-500' } },
  { value: ReservationStatus.RETURN_ISSUE, label: 'Problema en la devolución', visual: { icon: 'error', color: 'text-red-600' } },
  { value: ReservationStatus.PAYMENT_FAILED, label: 'Pago fallido', visual: { icon: 'error', color: 'text-red-500' } },
];

export const STATUS_VISUALS: Record<string, { bg: string; text: string; icon: string }> = Object.fromEntries(
  RESERVATION_STATUS_OPTIONS.map((o) => [
    o.value,
    {
      bg: 'bg-gray-100',
      text: o.visual?.color || 'text-gray-800',
      icon: o.visual?.icon || 'default',
    },
  ])
) as Record<string, { bg: string; text: string; icon: string }>;

// Tweak some backgrounds for important states
if (STATUS_VISUALS[ReservationStatus.PENDING_PAYMENT]) STATUS_VISUALS[ReservationStatus.PENDING_PAYMENT].bg = 'bg-yellow-100';
if (STATUS_VISUALS[ReservationStatus.CONFIRMED]) STATUS_VISUALS[ReservationStatus.CONFIRMED].bg = 'bg-blue-100';
if (STATUS_VISUALS[ReservationStatus.ACTIVE]) STATUS_VISUALS[ReservationStatus.ACTIVE].bg = 'bg-green-100';
if (STATUS_VISUALS[ReservationStatus.COMPLETED]) STATUS_VISUALS[ReservationStatus.COMPLETED].bg = 'bg-green-50';
if (STATUS_VISUALS[ReservationStatus.CANCELED]) STATUS_VISUALS[ReservationStatus.CANCELED].bg = 'bg-red-100';

export default RESERVATION_STATUS_OPTIONS;
